module.exports = __webpack_public_path__ + "img/2024shnh-4.08424f31.jpg";